import { useCompareStore } from '~/stores/useCompareStore'

export default ({ app, $pinia }: any) => {
  const compareStore = useCompareStore($pinia)

  const savedIds = app.$cookies.get('compare_list')

  if (savedIds && Array.isArray(savedIds)) {
    const partialProducts = savedIds.map(id => ({ id }))
    compareStore.setProducts(partialProducts)
  }

  compareStore.$subscribe((_, state) => {
    const idsOnly = state.products.map(p => p.id)

    app.$cookies.set('compare_list', idsOnly, {
      path: '/',
      maxAge: 60 * 60 * 24 * 30,
      sameSite: 'lax',
    })
  })
}
